export default __webpack_public_path__ + "static/media/star-yellow.77a224af.svg";